import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA4 from 'react-ga4';
import HomePage from './components/HomePage';
import SignUp from './components/SignUp';
import './firebase'; // This ensures Firebase is initialized before any components render
import Chat from './components/Chat';
import Users from './components/Users';
import Recover from './components/Recover';
import Header from './components/Header';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import ThankYou from './components/ThankYou';
import Profile from './components/Profile';
// This component will track page views
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    // Send pageview with the current location path
    ReactGA4.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
        // Scroll to top when location changes
        window.scrollTo(0, 0);
  }, [location]);
  
  return null;
}

function AppRoutes() {
  return (
    <>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<SignUp/>} />
        <Route path="/chat" element={<Chat/>} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/users" element={<Users/>} />
        <Route path="/recover" element={<Recover/>} />
        <Route path="/header" element={<Header/>} />
        <Route path="/footer" element={<Footer/>} />
        <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
        <Route path="/termsofservice" element={<TermsOfService/>} />
        <Route path="/cookiepolicy" element={<CookiePolicy/>} />
        <Route path="/thankyou" element={<ThankYou/>} />
        <Route path="/login" element={<SignUp/>} />
        <Route path="/chat/:userId?" element={<Chat />} />
       
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;